import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Edmond, OK?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through an Edmond post office or acceptance clerk can take 2–6 months, especially during busy travel seasons. For UCO students with study abroad deadlines, Oak Tree families with upcoming vacations, and professionals with business trips, that timeline is simply not viable.",
  },
  {
    q: "I am a UCO student with a study abroad program in Germany in 3 weeks. Can you help?",
    a: "Absolutely — this is one of the most common scenarios we handle for Edmond students. UCO study abroad programs to Germany, Spain, and Southeast Asia often have compressed timelines between acceptance and departure. First-time applicants (many UCO students) require an in-person acceptance clerk visit. We guide Edmond students through the exact Edmond Post Office or UCO campus location, forms, and timeline so they do not miss their program orientation. Most students receive their passport in 2–6 business days.",
  },
  {
    q: "Our family of 4 needs passport renewals for a European river cruise in 6 weeks. Can you coordinate?",
    a: "Yes — family group coordination is a specialty of ours. We handle Edmond families from Oak Tree, Coffee Creek, Spring Hollow, and Deer Creek regularly. We coordinate multiple renewal applications, child passport requirements if applicable, and group timelines to make sure every family member is ready for departure. Contact us as soon as you book your cruise.",
  },
  {
    q: "Can I renew my Edmond passport without visiting an acceptance facility?",
    a: "Yes. If your most recent passport was issued when you were 16 or older, is undamaged, and was issued within the last 15 years, you can renew by mail — no facility visit needed. Start online, ship your documents overnight from any Edmond or OKC UPS or FedEx location, and we handle the rest.",
  },
  {
    q: "Do I need to drive to Oklahoma City for a passport agency appointment?",
    a: "Not with Fast Passport Center. The Oklahoma City Passport Agency at 301 NW 6th Street is about 15 miles from Edmond, and appointments are often unavailable or weeks out. We provide a faster, simpler path through our reserved agency submission slots — you ship documents overnight from Edmond and we handle the submission, no OKC drive required.",
  },
  {
    q: "How quickly can Piedmont and Yukon residents receive an expedited passport?",
    a: "Piedmont and Yukon travelers have the same access to our expedited services as downtown Edmond residents. Since we operate remotely, your physical location in the north OKC metro does not affect processing speed. Ship your documents overnight from any Oklahoma County location, and we handle the rest. Most north OKC metro clients receive their passports within 2–9 business days.",
  },
  {
    q: "What documents do I need for an expedited passport from Edmond?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Can I use the Edmond Post Office or UCO campus for my acceptance clerk visit?",
    a: "Yes. The Edmond Main Post Office at 600 S Kelly Avenue and UCO Passport Services at 100 N University Dr both accept passport applications. We provide step-by-step instructions for your visit, including what to bring, what to expect, and how to properly seal your documents for overnight shipping to us after the clerk visit.",
  },
];

export default function EdmondFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Edmond and north OKC metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}